<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        margin: 5px;
        padding: 5px 0px;
      "
    >
      <div>
        {{ item.text || item.notes }}
        <br />
        {{ item.date1 || item.timestamp }} | {{ item.source }}
      </div>
      <div style="font-weight: bold; min-width: 50px; text-align: right">
        {{ item.amount || item.total }}
      </div>
      <div v-if="false">
        <br />

        {{ item.hash }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
